<template>
  <div class="activity">
    <div class="activity-top">
      <DActivityAvatar :activity="activity" />

      <div class="activity-title">
        <DActivityAuthor :activity="activity" />

        <span>
          added
          <a
            class="resource-link"
            :href="bookUrl"
            :title="activity.source.book.title"
            @click.stop
          >
            {{ activity.source.book.title }}
          </a>
          to
          <span v-if="!!activity.is_owner">your</span>
          <span v-else>the</span>
          bookshelf
        </span>

        <DActivityTimestamp
          :activity="activity"
          class="visible-until-sm"
        />
      </div>

      <DActivityTimestamp
        :activity="activity"
        class="hidden-until-md"
      />

      <DActivityActions
        v-if="isUserSignedIn && !isRepost"
        :activity="activity"
        @activity-removed="activityRemoved"
      />
    </div>

    <DActivityBook
      :book="activity.source.book"
      :book-url="bookUrl"
      class="space-top-2em"
      :is-external="activity.source.book_type === 'ExternalBook'"
      :is-user-signed-in="isUserSignedIn"
    />
  </div>
</template>

<script>
import URLS from '@d-shared/urls/urls';

import activityMixin from '../shared/activity-mixin';

export default {
  mixins: [
    activityMixin,
  ],
  data: () => ({
    bookUrl: null,
  }),
  mounted() {
    this.setBookUrl();
  },
  methods: {
    setBookUrl() {
      this.$set(
        this,
        'bookUrl',
        URLS.app.bookUserReviews.replace('<book-slug>', this.activity.source.book.slug),
      );
    },
  },
};
</script>
